var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1352 540",
    style: {
      enableBackground: "new 0 0 1352 540"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#020100;}\r\n\t.st1{font-family:'Cocogoose';}\r\n\t.st2{font-size:216.4395px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1275.19,303.68c-7.93-45.19-43.69-81-88.64-91c-5-1.11-5.15-1.49-12.67-2.14 c-7.52-0.65-11.95-0.52-17.27-0.19c-5.32,0.33-6.56,0.79-9.81,1.37c-4.6,0.83-9.06,1.86-13.37,3.09v30.12l-20.78-6.35l-4.55,19.06 l-6.87,7.42l-5.28,12.46h-12.53l-11.69,7.14l5.19,17.1c0,0-11.11-10.73-22.49-4.46c-4.46,18.19-3.7,36.84,3.59,55.86 c7.66,19.98,17.95,38.53,29.37,56.51c19.26,30.31,41.16,58.66,64.2,86.16c4.06,4.84,8.23,9.59,12.55,14.61 c1.16-1.28,2.08-2.26,2.96-3.27c19.84-22.78,38.63-46.39,56.1-71.03c16.16-22.8,31.25-46.26,42.73-71.87 C1274.64,344.91,1278.96,325.15,1275.19,303.68z M1226.92,315.78c-1.67,33.24-29.15,59.67-62.8,59.67 c-33.65,0-61.13-26.44-62.8-59.67c-0.06-1.06-0.09-2.13-0.09-3.2s0.03-2.14,0.09-3.2c1.67-33.24,29.15-59.67,62.8-59.67 c33.65,0,61.13,26.44,62.8,59.67c0.06,1.06,0.09,2.13,0.09,3.2S1226.98,314.72,1226.92,315.78z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.14,309.06l84.22,4.36c0,0,5.81-4.36,11.19,12.34c0,18.88,0,18.88,0,18.88h9.14 c0,0,13.79,12.34-5.81,27.59c-26.86-2.18-43.05,0-43.05,0v9.44h-9.22l-1.45,7.26h-15.97l-0.73,35.58h27.38 c0,0,13.28-6.05,18.37,11.86c-1.45,20.81,0.73,11.13,0.73,11.13s-45.01,1.71-82.04,0c0-41.87-26.14-48.96-26.14-48.96h-10.16 v-11.06l-14.52,0.73v-9.92h-11.62v-13.07h-58.08v-16.94l56.63,1.45l72.6,2.9L306.14,309.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305.42,240.81l7.26,68.25h-6.53l-9.26-64.62l-59.71-3.63l-2.18,108.91l-56.63-1.45c0,0,0-7.99,0-25.41 c-4.36-18.15,16.7-13.79,16.7-13.79h12.34c0,0,7.99-0.73,5.81,13.79c9.44,0.73,9.44,0.73,9.44,0.73l1.45-78.41l-0.73-12.1 l10.89-3.15l62.62,3.15L305.42,240.81z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "223.38,233.07 224.1,245.17 206.68,256.3 202.32,309.06 195.06,309.06 200.14,256.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.65,394.73h42.84l32.43,10.89c0,0,15.49-2.9,19.84,36.3c0,31.22-14.52,39.21-14.52,39.21H418.3 c0,0,6.19-8.71,10.91-21.78c8.35-34.12-10.91-47.19-10.91-47.19L381.65,394.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.06,394.73h44.29l28.32,10.89c0,0,23.96,3.63,23.96,48.64c-8.71,26.86-14.52,26.86-14.52,26.86h-47.19 c0,0,6.53-7.02,13.43-20.33c6.9-13.31,2.54-35.58-3.99-43.56C232.82,409.26,195.06,394.73,195.06,394.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.57,411.69l-24.69-10.72l-19.6-3.8l-18.15,7.26l-29.77,11.62c0,0-39.21,36.13,3.63,61.71 c55.2,1.67,16.7,0.73,92.21,0C260.4,438.8,217.57,411.69,217.57,411.69z M137.54,469.52c-7.62,0-13.79-11.7-13.79-26.14 s6.18-26.14,13.79-26.14s13.79,11.7,13.79,26.14S145.16,469.52,137.54,469.52z M160.45,431.76c-3.61,0-6.53-5.04-6.53-11.25 c0-6.22,2.93-11.25,6.53-11.25c3.61,0,6.53,5.04,6.53,11.25C166.99,426.72,164.06,431.76,160.45,431.76z M188.53,431.76 c-3.61,0-6.53-5.04-6.53-11.25c0-6.22,2.93-11.25,6.53-11.25s6.53,5.04,6.53,11.25C195.06,426.72,192.14,431.76,188.53,431.76z  M210.31,469.52c-7.62,0-13.79-11.7-13.79-26.14s6.18-26.14,13.79-26.14c7.62,0,13.79,11.7,13.79,26.14 S217.93,469.52,210.31,469.52z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.65,318.33c19.89-41.29,78.78-104.98,129.61-130.38c50.83-25.4,145.61-59.37,170.37-67.05 c24.76-7.68,49.57-4.71,45.74-30.09c-3.83-25.38-96.1,2.95-138.88,10.6c-33.34,6.03-122.97,24.58-141.12,33.71 c-18.15,9.13-48.69,57.84-82.67,125.24C282.74,327.77,333.65,318.33,333.65,318.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M679.6,98.39c-82.5-4.45-233.81,59.72-261.32,74.27c-28.44,15.04-71.69,73.68-96.92,129.05l-2.15,16.02 c7.2,1.94,14.44,0.6,14.44,0.6c19.89-41.29,78.78-104.98,129.61-130.38c50.83-25.4,145.61-59.37,170.37-67.05 C655.6,114.1,677.58,115.65,679.6,98.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.38,265.86c11.91-18.88,56.72-114.04,92.54-126.49s219.72-50.78,237.34-51.01 c17.61-0.23,20.95,7.21,20.95,7.21s-1.43-14.72-23.41-12.46c-21.98,2.26-100.57,18.6-165.16,32.68s-80.95,17.62-92.43,26.52 c-11.48,8.89-63.69,91.46-75.52,114.3c-11.83,22.85-4.78,38.85-0.45,29.86C324.56,277.48,326.38,265.86,326.38,265.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M851.3,135.54c-20.16-15.4-95.87-32.99-127.89-39.29c-32.02-6.3-118.31-35.45-138.29-36.94 c-19.97-1.49-45.38-1.02-48.47,24.87c-3.08,25.89,26.17,53.16,45.7,56.54c19.52,3.38,262.67,15.57,271.8,16.16 c9.13,0.59-2.93-24.5-2.93-24.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M548.24,110.51c-2.14-26.24,4.67-36.55,27.85-38.89c23.18-2.34,90,21.17,114.17,27.34 c24.17,6.17,140,35.21,145.04,38.58c5.04,3.37,9.21-1.74-12.57-9.29c-21.78-7.55-123.71-34.1-150.89-41.23 c-27.18-7.13-83.49-26.89-107.49-23.84C540.35,66.24,537.34,89.07,548.24,110.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M828.18,142.06c-5.57,7.49-18.54,7.92-41.99,6.41c-23.45-1.52-130.7-9.3-134.87-10.41 c-4.17-1.12-7.38-13.84-14.52-21.51c-7.14-7.67-21.65-3.1-25.06,7.08c-1.27,3.79,2.52,11.63,8.28,20.21 c64.39,4.27,189.54,10.69,224.88,12.55c-0.51-4.36-0.96-8.63-0.96-8.63L828.18,142.06z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M951.49,82.51l-99.07,75.23c0,0,63.93-5.26,120.77,112.6c49.18-43.35,110.47-97.38,110.47-97.38 s-37.87-43.38-71.76-73.79C977.08,73.41,951.49,82.51,951.49,82.51z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1091.05,181.35 1143.74,241.12 1133.15,250.46 1095.48,224.51 1078.19,192.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1055.24,212.92 1107.93,272.69 1097.33,282.03 1059.66,256.08 1042.37,224.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1021.19,242.93 1073.88,302.71 1063.28,312.05 1025.61,286.09 1008.32,254.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "987.39,272.72 1040.08,332.5 1029.49,341.84 991.82,315.88 974.53,284.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "959.84,290.28 975.8,320.59 838.47,288.36 816.46,263.39  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M639.08,175.03l171.08,52.23l4.17,24.56l144.13,26.23l-31.89-55.25c0,0,28.01,31.78-23.34-26.48 c-53.61-50.9-84.1-9.23-84.1-9.23l-8.68,13.03c0,0-46.29-22.39-88.65-33.45c-21.79-17.09-59.61-6.61-59.61-6.61L639.08,175.03z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1124.32,190.59 1132.76,190.59 1132.76,204.49 1124.32,210.07 1119.78,204.49 1114.15,193.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1056.96,269.43 1062.96,269.43 1062.96,272.72 1056.96,274.05 1053.72,272.72 1049.72,270.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1075.88,209.94 1080.1,209.94 1080.1,216.88 1075.88,219.68 1073.61,216.88 1070.8,211.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1013.96,275.02 1018.18,275.02 1018.18,281.97 1013.96,284.76 1011.69,281.97 1008.88,276.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1041.28,238.15 1049.72,238.15 1049.72,252.04 1041.28,257.63 1036.74,252.04 1031.11,240.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1095.59,243.02 1099.81,243.02 1099.81,249.97 1095.59,252.76 1093.32,249.97 1090.51,244.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1056.77,257.63 1060.99,257.63 1060.99,264.58 1056.77,267.37 1054.5,264.58 1051.69,258.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1112.08,170.51 1116.3,170.51 1116.3,177.46 1112.08,180.25 1109.8,177.46 1106.99,171.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1075.88,195.46 1080.1,195.46 1080.1,202.41 1075.88,205.2 1073.61,202.41 1070.8,196.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1085.03,224.41 1091.03,224.41 1091.03,227.7 1085.03,229.02 1081.79,227.7 1077.79,225.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1116.52,138.73 1124.96,138.73 1124.96,152.62 1116.52,158.21 1111.97,152.62 1106.35,141.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1091.46,149.43 1095.68,149.43 1095.68,156.38 1091.46,159.17 1089.19,156.38 1086.38,150.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1041.28,313.48 1049.72,313.48 1049.72,327.37 1041.28,332.96 1036.74,327.37 1031.11,316.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "998.38,253.65 1006.82,253.65 1006.82,267.54 998.38,273.13 993.84,267.54 988.21,256.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1071.92,137.55 1080.36,137.55 1080.36,151.44 1071.92,157.03 1067.37,151.44 1061.75,140.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1138.75,167.01 1147.2,167.01 1147.2,180.91 1138.75,186.49 1134.21,180.91 1128.59,169.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1021.53,294.94 1025.75,294.94 1025.75,301.89 1021.53,304.68 1019.26,301.89 1016.45,296.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1043.07,343.14 1047.29,343.14 1047.29,350.08 1043.07,352.88 1040.79,350.08 1037.98,344.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1021.53,343.14 1025.75,343.14 1025.75,350.08 1021.53,352.88 1019.26,350.08 1016.45,344.44  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 467.5215 476.021)",
    className: "st1 st2"
  }, "TMP"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e61cf72d.svg";
export { ForwardRef as ReactComponent };